import { render, staticRenderFns } from "./CatalogDeleteConfirm.vue?vue&type=template&id=17d1dad1&"
import script from "./CatalogDeleteConfirm.vue?vue&type=script&lang=js&"
export * from "./CatalogDeleteConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports